import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { LicenseOrder } from "Components/Licenses/LicenseOrder";
import { LicensePayment } from "Components/Licenses/LicensePayment";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useSearchParams } from "Navigation/useSearchParams";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { Box } from "@mui/material";

const LicenseOrderPage = () => {
  const { t } = useResource();
  const [searchParams] = useSearchParams();
  const transactionID = searchParams.get("transaction");

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.LicenseOrder)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("licenses"),
      }}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <PrimaryPaper>
            {transactionID ? (
              <LicensePayment transactionPublicID={transactionID} />
            ) : (
              <LicenseOrder />
            )}
          </PrimaryPaper>
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default LicenseOrderPage;
